import React, { createRef, FC, useEffect, useState } from 'react';
import cls from 'classnames';
import { useAtomValue } from 'jotai';
import { $LikeCountConfirmModalStatus } from './atom';
import { FixBodyUtil } from '~/utils/fix-body';
import { useResetAtom } from 'jotai/utils';
import { $CurrentUserAsAvailable } from '@user/shared/current-user';
import { useTranslation } from 'react-i18next';

import './style.scss';

const LikeCountConfirm: FC = () => {
  const { t } = useTranslation();

  const user = useAtomValue($CurrentUserAsAvailable);
  const status = useAtomValue($LikeCountConfirmModalStatus);
  const close = useResetAtom($LikeCountConfirmModalStatus);
  // 是否显示动画
  const [isShowAnimation, setIsShowAnimation] = useState(false);

  const confirmRef = createRef<HTMLDivElement>();

  useEffect(() => {
    if (status) {
      FixBodyUtil.fix();
      setIsShowAnimation(true);
    } else {
      FixBodyUtil.restore();
    }
  }, [status]);

  return (
    <div
      className={cls('like-confirm', {
        show: Boolean(status),
        hide: !status,
        'show-animation': isShowAnimation,
      })}
      ref={confirmRef}
    >
      <div className="like-confirm-container">
        <div className="title-container">{t('profile_likes_favors_count')}</div>
        <div className="count-confirm-container">
          <div className="like-container">
            <div className="like-img" />
            <div className="like-count">{user.dugCount}</div>
          </div>
          <div className="vertical-line" />
          <div className="collection-container">
            <div className="collection-img" />
            <div className="collection-count">{user.favoredCount}</div>
          </div>
        </div>
        <div className="like-confirm-button-container" onClick={close}>
          <div className="sure-btn">{t('profile_likes_favors_confirm')}</div>
        </div>
        <div />
      </div>
      <div className="overlay" />
    </div>
  );
};

export default LikeCountConfirm;
